'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var moduleName = 'appConstants';

angular.module(moduleName, [])
    .constant('Api', {
        IMAGES: 'https://sport.brainvt.com/',
        Public: 'https://sport.brainvt.com/',
        Path: 'https://sport.brainvt.com/api/',
        AuthPath: 'https://sport.brainvt.com/oauth/v2/token',
        ClientId: '8_tc087udzsmook4ok00sk8occgk0w04kkgssgogco0w0sog4c0',
        ClientSecret: 'spa0m79gsm8k888wswss00gssskkkk8c88kowcc8wcg0ks4gs',
        TPVURL: 'https://sis-t.redsys.es:25443/sis/realizarPago',
        IBAN: 'ES84 2100 0254 8602 0044 3515'
    });

exports.default = moduleName;
module.exports = exports['default'];



/** WEBPACK FOOTER **
 ** ./js/constants.js
 **/